import { Box, Stack, Typography } from '@mui/material';

import { useColorTokens } from '@/app/themes';
import { Button } from '@/shared/components/button';
import { Info, RotateCW } from '@/shared/components/icons';

interface MapEmptyProps {
  headingText?: string;
  subHeadingText?: string;
  handleReload: () => void;
}

const MapError = ({
  headingText = 'Data failed to load',
  subHeadingText = 'Try reloading the page.',
  handleReload,
}: MapEmptyProps) => {
  const { red } = useColorTokens();

  return (
    <Stack
      direction='row'
      gap={1.5}
      p={2}
      sx={{
        borderRadius: 1,
        border: 1,
        borderColor: red[100],
        backgroundColor: red[5],
      }}
    >
      <Info fontSize='small' sx={{ color: red[200] }} />
      <Box>
        <Typography variant='body1' component='h2' sx={{ color: red[200] }}>
          {headingText}
        </Typography>
        <Typography
          variant='body14'
          component='p'
          fontWeight={400}
          pt={0.75}
          sx={{ color: red[100] }}
        >
          {subHeadingText}
        </Typography>

        <Box pt={1.2}>
          <Button
            size='small'
            endIcon={<RotateCW />}
            color='inherit'
            onClick={handleReload}
          >
            Reload
          </Button>
        </Box>
      </Box>
    </Stack>
  );
};

export default MapError;
